import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    FETCH_CAR_LIST_SUCCESS
`,
    {
        prefix: "sellusedcarseo/"
    }
);
